import React, { Fragment, useState } from 'react';
import { Button, Dialog, DialogContent, DialogTitle, DialogActions } from '@material-ui/core';
import { Field, Formik } from 'formik';
import * as Yup from 'yup';

import { GQLDeliveryUnitSaleCatalog, GQLParty } from '@jewelutions/core-crm-server-api-client-domain';
import { ErrorComponent, JwlField, LoadingSpinner } from '../../../../components';
import { GQLOperationBuilder } from '../../../../operations/GQLOperationBuilder';

interface IProps {
  deliveryUnitSaleCatalog: GQLDeliveryUnitSaleCatalog;
  party: GQLParty;
  onClose: (success: boolean) => void;
}

export const DeliveryUnitSaleCatalogEditDialog: React.FC<IProps> = ({
  deliveryUnitSaleCatalog,
  party,
  onClose
}: IProps) => {
  const [errorComponentState, setErrorComponentState] = useState(false);
  const [deliveryUnitSaleCatalogToPersist, setDeliveryUnitSaleCatalogToPersist] = useState(null as any);
  const initialValues = {
    name: deliveryUnitSaleCatalog.name.en,
    description: deliveryUnitSaleCatalog.description.en
  };

  const [
    updateNameAndDescription,
    { error: errorUpdateNameAndDescription, loading: createUpdateNameAndDescriptionLoader }
  ] = GQLOperationBuilder.deliveryUnitSaleCatalog.updateNameAndDescription();

  const onSubmit = (props: any) => {
    const mutationVariables = {
      name: { en: props.name },
      description: { en: props.description },
      deliveryUnitSaleCatalogId: deliveryUnitSaleCatalog.id
    };

    setDeliveryUnitSaleCatalogToPersist(props);
    updateNameAndDescription({ variables: mutationVariables }).then(response => {
      onClose(true);
    });
  };

  if (errorUpdateNameAndDescription && !errorComponentState)
    return (
      <Dialog open={true} maxWidth="md" aria-labelledby="edit-delivery-unit-sale-catalog">
        <ErrorComponent
          margins="0"
          close={setErrorComponentState}
          callback={() => onSubmit(deliveryUnitSaleCatalogToPersist)}
          details={errorUpdateNameAndDescription?.stack}
          message={errorUpdateNameAndDescription?.message}
        />
      </Dialog>
    );

  if (createUpdateNameAndDescriptionLoader) return <LoadingSpinner />;

  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    description: Yup.string().required('Description is required')
  });

  return (
    <Dialog open={true} aria-labelledby="edit-delivery-unit-sale-catalog">
      <Fragment>
        <DialogTitle>Edit delivery unit catalog</DialogTitle>
        <DialogContent>
          <Formik
            initialValues={{ ...initialValues }}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({ values, touched, handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Field name="name" component={JwlField} label="Name" />
                <Field name="description" component={JwlField} label="Description" />

                <DialogActions>
                  <Button color="primary" onClick={() => onClose(false)}>
                    Close
                  </Button>
                  <Button type="submit" color="primary" variant="contained">
                    Save
                  </Button>
                </DialogActions>
              </form>
            )}
          </Formik>
        </DialogContent>
      </Fragment>
    </Dialog>
  );
};

export default DeliveryUnitSaleCatalogEditDialog;
